module.exports = __webpack_public_path__ + "img/fistBody.d9351536.svg";